export enum ColleaguesTabsEnum {
  PARTICIPANTS = "participants",
  BLACKLIST = "blacklist",
  REQUESTS = "requests",
  DEPARTMENT = "department",
}
